import { Directive, HostBinding, Input } from '@angular/core';
import { BREAKPOINTS_PX } from '@vendasta/galaxy/constants';

export const WidthPreset = {
  Narrow: 'narrow',
  Default: 'default',
  Wide: 'wide',
  Full: 'full',
} as const;

export type WidthPreset = (typeof WidthPreset)[keyof typeof WidthPreset];

@Directive({
  selector: 'glxy-page-wrapper, [glxyPageWrapper]',
  standalone: false,
})
export class PageWrapperDirective {
  @HostBinding('class') class = 'glxy-page-wrapper';

  @HostBinding('style.display') display = 'block';

  @HostBinding('style.margin') margin = '0 auto';

  @Input() widthPreset: WidthPreset = WidthPreset.Default;

  @Input() maxWidth?: number;

  @HostBinding('style.max-width')
  get setMaxWidth(): string {
    if (this.maxWidth) {
      return this.maxWidth + 'px';
    } else {
      switch (this.widthPreset) {
        case 'narrow':
        case WidthPreset.Narrow:
          return BREAKPOINTS_PX.TABLET_MINIMUM;
        case 'wide':
        case WidthPreset.Wide:
          return '1160px';
        case 'full':
        case WidthPreset.Full:
          return '';
        case 'default':
        case WidthPreset.Default:
        default:
          return '900px';
      }
    }
  }
}
